<template>
  <div id="cashierOrderVipRecharge">
    <div class="rc-title flex-between alignCenter">
      <div class="center back" @click="back(false)">
        <span style="margin-right:7px;">
          <img src="../../assets/icon/turnLeft.png" alt />
        </span>会员充值
      </div>
      <div class="back" @click="back(true)" style="color: gray;font-size: 20px;">X</div>
    </div>
    <div class="content">
      <div style>
        <span style="font-weight:bold;">{{phoneNum}}</span> 还不是会员，快速办理，享
        <span style="color:#108EE9">VIP</span>权益
      </div>
      <div style="margin-top:20px">
        <span style="margin-right:5px">
          <img src="../../assets/icon/rectangle.png" alt />
        </span>填写会员信息
      </div>
      <div class="warp row">
        <div class="key alignCenter">会员姓名</div>
        <div class="value alignCenter">
          <input placeholder="请输入会员姓名" v-model="vipName" />
        </div>
      </div>
      <div class="warp row">
        <div class="key alignCenter">会员生日</div>
        <div class="value2 alignCenter">
          <div class="block">
            <el-date-picker
              v-model="birthday"
              value-format="yyyy-MM-dd"
              type="date"
              placeholder="选择生日"
            ></el-date-picker>
          </div>
        </div>
      </div>
      <div class="warp row">
        <div class="key alignCenter">会员卡</div>
        <div class="value2 alignCenter">
          <el-select
            v-model="shopMemberCardId"
            @change="selectChange(shopMemberCardId)"
            placeholder="选择会员卡"
          >
            <el-option
              v-for="(item,index) in vipList"
              v-if='item.isEnable'
              :label="item.cardName"
              :value="item.shopMemberCardId"
              :key="index"
            ></el-option>
          </el-select>
          <div class="isEnable2">
            <span class="content2-ygq2" v-if="isExpireShow2">已过期</span>
            <span class="content2-jyz2" v-if="isEnableShow2">禁用中</span>
          </div>
        </div>
      </div>
      <div class="warp row">
        <div class="key alignCenter"></div>
        <div class="value2 alignCenter">
          <el-button type="primary" @click="back(false)" plain>上一步</el-button>
          <el-button type="primary" @click="success">确定办卡</el-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  shopMemberList,
  activityList,
  shopMemberRecharge,
  getBindWxQrValue
} from "../api";
export default {
  data() {
    return {
      phoneNum: "", //会员手机号
      userList: "",
      shopInformation: "",
      vipName: "", //会员名
      birthday: "", //会员生日
      shopMemberCardId: "", //选择的会员卡id
      vipList: [],
      isExpireShow2: false,
      isEnableShow2: false
    };
  },
  created() {
    let userList = JSON.parse(this.getCookie("userList"));
    let shopInformation = JSON.parse(this.getCookie("shopInformation"));
    this.userList = userList;
    this.shopInformation = shopInformation;
    this.phoneNum = this.$route.query.phoneNum;
    this.ShopMemberCard_shopMemberCardList();
  },
  methods: {
    success() {
      if (!this.vipName) {
        this.$message.error("请填写会员姓名");
        return;
      } else if (!this.shopMemberCardId) {
        this.$message.error("请选择会员卡");
        return;
      } else if (!this.birthday) {
        this.$message.error("请选择生日");
        return;
      }
      getBindWxQrValue({
        sessionId: this.userList.sessionId,
        userId: this.userList.id,
        fullName: this.vipName,
        phoneNum: this.phoneNum,
        shopMemberCardId: this.shopMemberCardId,
        birthday: this.birthday
      })
        .then(res => {
          // console.log(res.data, "获取商品列表");
          if (res.code == 1) {
            this.$message({
              type: "success",
              message: "办理成功"
            });
            this.back(false);
            this.$store.state.newShopMemberId = res.data.shopMemberId; //暂存新会员id
          } else if (res.code == 2) {
            this.$message.error(res.msg);
            this.$router.push("/");
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch(function(error) {
          //   alert("商品接口网络错误，不能访问");
          //   console.log(error);
        });
    },
    //当前店铺的会员卡列表
    ShopMemberCard_shopMemberCardList() {
      this.request
        .post("qrcapi/ShopMemberCard_shopMemberCardList", {
          userId: this.userList.id, //用户Id
          sessionId: this.userList.sessionId
        })
        .then(res => {
          // console.log(res.data,'会员卡列表')
          var a = res.data;
          this.vipList = a;
          console.log(this.vipList, "this.vipList");
          console.log(res, "当前店铺的会员卡列表");
        });
    },
    selectChange(e, type) {
      for (let i of this.vipList) {
        if (i.shopMemberCardId == e) {
          if (i.isEnable == 0) {
            this.isEnableShow2 = true;
          } else {
            this.isEnableShow2 = false;
          }
          if (i.isExpire == 1) {
            this.isExpireShow2 = true;
          } else {
            this.isExpireShow2 = false;
          }
        }
      }
    },
    back(a) {
      if (a) {
        this.$router.push("/cashierOrder/cashierOrderHome");
        return;
      }
      this.$router.go(-1);
    }
  }
};
</script>

<style scoped>
.value2 {
  position: relative;
}
.content2-jyz2 {
  border: 1px solid #f6ae23;
  color: #f6ae23;
  font-size: 10px;
  border-radius: 5px;
  padding: 2px 7px;
}
.content2-ygq2 {
  border: 1px solid #f62323;
  color: #f62323;
  border-radius: 5px;
  font-size: 10px;
  padding: 2px 8px;
}
.isEnable2 {
  position: absolute;
  right: 30px;
  top: 12px;
}
.unit {
  position: absolute;
  right: 10px;
}
input {
  border: none !important;
  padding: 10px;
}
.activityItem2 {
  padding: 10px 8px;
  border: 1px solid #108ee9;
  color: #108ee9;
  font-size: 12px;
  border-radius: 2px;
  margin-right: 10px;
}
.activityItem {
  padding: 10px 8px;
  border: 1px solid #cccccc;
  color: #666666;
  font-size: 12px;
  border-radius: 2px;
  margin-right: 10px;
}
.content {
  padding: 20px;
  font-size: 14px;
}
.activity {
  height: 100%;
  /* width: 300px; */
  padding-left: 10px;
}
.key {
  height: 100%;
  width: 80px;
  color: #666666;
  text-align: right;
}
.value {
  height: 100%;
  width: 300px;
  border-bottom: 1px solid #eee;
  padding-left: 10px;
  position: relative;
}
.warp {
  height: 45px;
  margin-bottom: 20px;
  font-size: 14px;
  position: relative;
  margin-left: 20px;
}
.back {
  cursor: pointer;
}
.rc-title {
  /* background: #eeeeee; */
  border-bottom: 1px solid #eee;
  box-sizing: border-box;
  padding: 18px;
  height: 60px;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: rgba(16, 142, 233, 1);
}
</style>


// WEBPACK FOOTER //
// src/components/page/cashierOrderAddVip.vue